/** @jsx jsx */
import { useContext, createContext, useReducer, useState } from "react";
import { css, jsx } from "@emotion/core";
import styled from "@emotion/styled";


///////////////
// CONSTANTS FILE 
///////////////
const ADD = "ADD";
const REMOVE = "REMOVE";
const CLEAR = "CLEAR";




///////////////
// ACTIONS FILE 
///////////////
const doAddTodo = (todo)  => ({
  type: ADD,
  payload: { todo }
})

const doClearTodos = ()  => ({
  type: CLEAR
})

const doRemoveTodo = (title)  => ({
  type: REMOVE,
  payload: { title }
})







///////////////
// REDUCER FILE
///////////////
const initialState = {
  todos: []
};
// manages state for this component
const reducer = (state, action) => {
  switch (action.type) {
    case ADD:
      return { todos: [...state.todos, action.payload.todo] };
    case REMOVE:
      return { todos: state.todos.filter(item => item !== action.payload.title) };
    case CLEAR:
      return { todos: [] }
    default:
      return { ...state };
  }
};









//////////////////
// MAIN FILE
//////////////////
const TodoDispatch = createContext(null);

export default function Nothing() {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <TodoDispatch.Provider value={dispatch}>
      <Container>
        <AddTodo />
        <TodoItems items={state.todos} />
        <Clear />
      </Container>
    </TodoDispatch.Provider>
  );
}

const Container = styled.div`
  width: 500px;
  border: 1px solid white;
  padding: 1em;
  margin: 4em auto;
`










//////////////////
// CLEAR FILE
//////////////////
function Clear() {
  const dispatch = useContext(TodoDispatch)
  return (
    <div css={clearCSS} onClick={() => dispatch(doClearTodos())}>CLEAR</div>
  )
}

const clearCSS = css`
  color: lightgreen;
  cursor: pointer;
`









///////////////
// TODO ITEMS FILE
///////////////
const TodoItems = ({ items }) => {
  const dispatch = useContext(TodoDispatch)
  return (
    <div>
      {items.map(title => (
        <Item onClick={() => dispatch(doRemoveTodo())}>{title}</Item>
      ))}
    </div>
  );
};

const Item = styled.div`
  color: white;
  font-size: 20px;
  &:hover {
    color: lightcoral;
    cursor: pointer;
  }
`








///////////////
// ADD TODO FILE
///////////////

const AddTodo = () => {
  // used to interact with parent
  const dispatch = useContext(TodoDispatch);

  // monitors internal input variable
  const [todo, setTodo] = useState("");

  const handleSubmit = e => {
    e.preventDefault();
    dispatch(doAddTodo(todo));
    setTodo("");
  };

  return (
    <form onSubmit={handleSubmit} style={{paddingBottom: '1em'}}>
      <input type="text" onChange={e => setTodo(e.target.value)} value={todo} />
    </form>
  );
};
